// @flow

import alt from '../alt';

class SchemaActions {
	changeValue(field, value) {
		return {
			field: field,
			value: value
		};
	}
	
	/**
	 * Algatatakse schema laadimine serverist
	 */
	fetchSchema(schema) {
		return schema;
	}
	
	/**
	 * Schema laadimine ebaõnnestus
	 */
	fetchSchemaFailed(error) {
		return error;
	}
	
	/**
	 * Schema sai laetud
	 */
	fetchSchemaDone(data) {
		return data;
	}
}

export default alt.createActions(SchemaActions);
